import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Sidebar from '../Sidebar/Sidebar'
// import '../../../src/App.css';
import { Route, Routes, Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomerRegistration from '../CustomerRegistration/CustomerRegistration';
import EmployeeRegistration from '../CustomerRegistration/EmployeeRegistration';
import CustomerDashboardPage from './CustomerDashboardPage';
import CustomerProfile from '../ProfileManagement/CustomerProfile';
import CustomerProfileDocumentationList from '../CustomerKycDocuments/CustomerProfileDocumentationList';
import { getCustomerProfileData } from '../../Redux/action/Admin/CustomerAction';
import { useDispatch, useSelector } from 'react-redux';
import UnderDevelopmentPage from '../UnderDevelopmentPage';
import CustomerContractManagementList from '../ContractManagement/CustomerContractManagementList';
import Beatloader from '../../Common/Loaders/Beatloader';
import QueryManagementList from '../QuotationManagement/QueryManagementList';
import CustomerQueryInformation from '../QuotationManagement/CustomerQueryInformation';
import AddQuery from '../QuotationManagement/AddQuery';



const CustomerDashboard = ({ CompanyDetailData, showProduction }) => {
    const [showSideBar, setShowSideBar] = useState(false);
    const [showLoader, setShowLoader] = useState(true);
    const [showRejectionAlert, setShowRejectionAlert] = useState(false);
    const dispatch = useDispatch();

    const navigate = useNavigate()
    const customertoken = Cookies.get('customertoken');
    let [loadProfile, setLoadProfile] = useState(false);

    const [showSideNavBar, setShowSideNavBar] = useState(true);
    useEffect(() => {
        if (window.opener) {
            setShowSideNavBar(false);
        } else {
            setShowSideNavBar(true);
        }
    }, []);

    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;

    const [disbaledProfileEditing, setDisableProfileEditing] = useState(false);

    useEffect(() => {
        if (!customertoken) {
            toast.error("Please login to continue.");
            navigate(`/customer/login?burl=${encodeURIComponent(q)}`);
        }
    }, [customertoken, dispatch, navigate, q]);

    useEffect(() => {
        if (customertoken) {
            dispatch(getCustomerProfileData(customertoken));
        }
    }, [])

    // useEffect(()=>{
    //     if(loadProfile){
    //         console.log("Hitting dashboard.")
    //         dispatch(getCustomerProfileData(customertoken));
    //     }
    // },[loadProfile])


    const refreshCustomerDetails = () => {
        if (customertoken) {
            dispatch(getCustomerProfileData(customertoken));
        }
    }

    let {
        loadingCustomerProfileDataApi, CustomerProfileDataError, CustomerProfileData,
    } = useSelector(state => state?.CustomerReducer);


    useEffect(() => {
        // console.log("loadingCustomerProfileDataApi", loadingCustomerProfileDataApi)
        if (loadingCustomerProfileDataApi) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }


        if (CustomerProfileData) {
            if (CustomerProfileData?.profileCompleted && CustomerProfileData.approval === "APPROVED") {
                setDisableProfileEditing(true);
            } else {
                setDisableProfileEditing(false);
            }
        }
    }, [loadingCustomerProfileDataApi, CustomerProfileData])


    // const hasPermission = (requiredPermissions) => {
    //   return requiredPermissions.every(permission => accessedPermission.includes(permission));
    // };

    return (
        <div>
            {customertoken ?
                showLoader ?
                    <Beatloader />
                    :
                    <div className={showSideNavBar ? `main-wrapper` : ""}>
                        {showSideNavBar && <>
                            <Navbar sidebar="sidebar" sidebarMenu="sidebar-menu" showSideNavBar={showSideNavBar} CompanyDetailData={CompanyDetailData} customertoken={customertoken}/>
                            <Sidebar sidebar="sidebar" sidebarMenu="sidebar-menu" CustomerProfileData={CustomerProfileData} showSideNavBar={showSideNavBar} />
                        </>}


                        <Routes>
                            <Route index element={<Navigate to="/dashboard" />} />
                            <Route path='dashboard' element={<CustomerDashboardPage showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} />
                            {(CustomerProfileData?.profileCompleted && CustomerProfileData.approval !== "DISAPPROVED") ?

                                <Route path='profile' element={<CustomerProfile loadingCustomerProfileDataApi={loadingCustomerProfileDataApi} CustomerProfileDataError={CustomerProfileDataError} CustomerProfileData={CustomerProfileData} refresh={refreshCustomerDetails} disbaledProfileEditing={disbaledProfileEditing} />} />
                                :
                                <Route path='profile' element={<EmployeeRegistration />} />
                            }

                            <Route path='documents' element={<CustomerProfileDocumentationList showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} />
                            <Route path='customer-registration' element={<EmployeeRegistration showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} />
                            {/* <Route path='quotation-list' element={<UnderDevelopmentPage showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} /> */}
                            <Route path='all-orders' element={<UnderDevelopmentPage showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} />
                            <Route path='contract-list' element={<CustomerContractManagementList showRejectionAlert={showRejectionAlert} CustomerProfileData={CustomerProfileData} />} />
                            <Route path='query-list' element={<QueryManagementList showTabs={false} />} />
                            <Route path='add-query' element={<AddQuery showProduction={showProduction}/>} />
                            <Route path='/query-information/:b64id' element={<CustomerQueryInformation showSideNavBar={showSideNavBar} />} />
                        </Routes>

                        {/* /Page Wrapper */}
                    </div>

                : <Navigate to="/customer/login" />
            }
        </div>


    )
}

export default CustomerDashboard